'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createMv = configure.configure(function (api) {
  function mv(_x, _x2) {
    return _mv.apply(this, arguments);
  }

  function _mv() {
    _mv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sources, destination) {
      var options,
          res,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

              if (!Array.isArray(sources)) {
                sources = [sources];
              }

              _context.next = 4;
              return api.post('files/mv', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: sources.concat(destination)
                }, options)),
                headers: options.headers
              });

            case 4:
              res = _context.sent;
              _context.next = 7;
              return res.text();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _mv.apply(this, arguments);
  }

  return mv;
});
exports.createMv = createMv;